import {SpinalLocation} from "./weak-entities";

export interface ThermalDataReading {
  LeftValue: number;
  RightValue: number;
  SpinSpinalLocation: SpinalLocation;
}

export class ThermalReadingData {
  constructor(encoder: number, leftIr: number, leftTherm: number, rightIr: number, rightTherm: number, timestamp: number) {
    this.Encoder = encoder;
    this.LeftIr = leftIr;
    this.LeftTherm = leftTherm;
    this.RightIr = rightIr;
    this.RightTherm = rightTherm;
    this.Timestamp = timestamp;
  }

  Encoder: number;
  LeftIr: number;
  LeftTherm: number;
  RightIr: number;
  RightTherm: number;
  Timestamp: number;
  Location: SpinalLocation;

  get Trigger(): boolean {
    return (this.Encoder & (1 << 7)) != 0;
  }

  get LeftStable(): boolean {
    return (this.Encoder & (1 << 6)) != 0;
  }

  get RightStable(): boolean {
    return (this.Encoder & (1 << 5)) != 0;
  }

  get LeftTemp(): number {
    return this.LeftIr + this.LeftTherm;
  }

  get RightTemp(): number {
    return this.RightIr + this.RightTherm;
  }

  get DiffTemp(): number {
    return Math.abs(this.RightTemp - this.LeftTemp);
  }

  get Distance(): number {
    let bit4 = this.Encoder & (1 << 4);
    let bit3 = this.Encoder & (1 << 3);
    let bit2 = this.Encoder & (1 << 2);
    let bit1 = this.Encoder & (1 << 1);
    return (bit4 * .1) + (bit3 * .1) + (bit2 * .1) + (bit1 * .1);
  }
}

export interface thermalData {
  distanceReadings?: number;
  eventMarkers: SpinalLocation;
  rightStable: boolean;
  leftStable: boolean;
  leftReadings: number;
  rightReadings: number;
  minDiffValue: number;
  leftIr: number;
  rightIr: number;
}

export interface ThermalStatus {
  FirmwareMajor: number;
  FirmwareMinor: number;
  Firmware: string;
  StreamStatus: number;
  Flag: number;
  DcInputVoltage: number;
  BatteryVoltage: number;
  ProgramCounter: number;
}

export interface ThermalConfig {
  MyAddress: number;
  SerialNumber: number;
  XOffsetCounts: number;
  XMaxCounts: number;
  YOffsetCounts: number;
  YMaxCounts: number;
  LcdXDimension: number;
  LcdYDimension: number;
  TouchThreshold: number;
  ThermistorCh1Gain: number;
  ThermistorCh1Offset: number;
  ThermistorCh2Gain: number;
  ThermistorCh2Offset: number;
  IrCh1Gain: number;
  IrCh1Offset: number;
  IrCh2Gain: number;
  IrCh2Offset: number;
  IrCh1Sync: number;
  IrCh2Sync: number;
  DisplayRange: number;
}

export enum ThermalScanStates {
  Init,
  Prescan,
  Scanning,
  ScanningLeftC1,
  ScanningRightC1,
  AwaitingComplete,
  Complete
}



// WEBPACK FOOTER //
// ./src/model/thermal.ts